import { Intent } from "@blueprintjs/core";
import { IconName, IconNames } from "@blueprintjs/icons";
import { ValidationState } from "in_queue/utils/customUpgradeValidation";

// Shared per-state intent and icon so the status tag (table/scenarios) and the
// dialog banner always stay visually in sync.
export const VALIDATION_INTENT: Record<ValidationState, Intent> = {
    usable: Intent.SUCCESS,
    failed: Intent.DANGER,
    validating: Intent.PRIMARY,
    stale: Intent.WARNING,
    noModelSet: Intent.NONE
};

export const VALIDATION_ICON: Record<ValidationState, IconName> = {
    usable: IconNames.TICK_CIRCLE,
    failed: IconNames.WARNING_SIGN,
    validating: IconNames.REFRESH,
    stale: IconNames.HISTORY,
    noModelSet: IconNames.DISABLE
};
